/**
 * Centralized API base URL for the new auth + dashboard backend.
 * Used in src/api/api.tsx.
 */
export const API_BASE_URL = "https://api.valyrion.com/";
